import getInstance from "../config/api";

export default class User {
  static async fetchPartnerUsers(params) {
    const instance = getInstance();
    const { data } = await instance.get("/user/partner", { params });
    return data;
  }

  static async toggleUser(id) {
    const instance = getInstance();
    const { data } = await instance.put(`/user/toggle-active/${id}`);
    return data;
  }

  static async fetchUserById(id) {
    const instance = getInstance();
    const { data } = await instance.get(`/user/${id}`);
    return data;
  }

  static async createUser(body) {
    const instance = getInstance();
    const { data } = await instance.post("/user", body);
    return data;
  }

  static async updateUser(id, body) {
    const instance = getInstance();
    const { data } = await instance.put(`/user/${id}`, body);
    return data;
  }

  static async disableUser(id) {
    const instance = getInstance();
    const { data } = await instance.patch(`/user/${id}`);
    return data;
  }

  static async downloadUsersPartner(params) {
    const instance = getInstance();
    const data = await instance.get(`/user/partner-export`, { params });
    return data;
  }
  static async fetchAllUserHistoric(params) {
    const instance = getInstance();
    const { data } = await instance.get("/user/user-historic-all", { params });
    return data;
  }
  static async fetchUserHistoricByDate(params) {
    const instance = getInstance();
    const { data } = await instance.get(`/user/user-historic`, { params });
    return data;
  }
  static async fetchUserHistoricById(body) {
    const instance = getInstance();
    const { data } = await instance.post(`/user/user-historic-id`, body);
    return data;
  }
}
